import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase credentials');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export async function fetchCandidates() {
  const { data, error } = await supabase
    .from('candidates')
    .select('*');

  if (error) throw error;
  return data;
}

export async function fetchVendors() {
  const { data, error } = await supabase
    .from('vendors')
    .select('*');

  if (error) {
    console.error('Error fetching vendors:', error);
    throw error;
  }
  return data;
}

export async function fetchRoles() {
  const { data, error } = await supabase
    .from('projects')
    .select(`
      *,
      vendor:vendors (
        name,
        email
      )
    `);

  if (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
  return data;
}

export async function fetchRoleDetails(id: number) {
  const { data, error } = await supabase
    .from('projects')
    .select(`
      *,
      vendor:vendors(*)
    `)
    .eq('id', id)
    .single();

  if (error) throw error;
  return data;
}

export { analyticsService } from '@/services/analytics-service';
